import { useQuery } from '@tanstack/react-query';

import { hubFetch } from '@/api/client';
import type { AiUsageReport } from '@/api/types';
import { useEnvStore } from '@/env/envStore';

import type { MonthsOption } from './types';

/**
 * Fetch the AI / Document Intelligence usage rollup for the env currently
 * selected in `EnvProvider`. The backend caches each (env, months)
 * key in-memory for 10 minutes, so a stale-time of 5 min on the client
 * keeps two consecutive page mounts inside that window from re-hitting
 * the API at all.
 */
export function useAiUsage(months: MonthsOption) {
  const env = useEnvStore((s) => s.env);
  return useQuery({
    queryKey: ['ai-usage', env, months],
    queryFn: (): Promise<AiUsageReport> =>
      hubFetch<AiUsageReport>('/api/ai-usage', {
        searchParams: { months },
      }),
    staleTime: 5 * 60_000,
    gcTime: 15 * 60_000,
  });
}
